import { gql } from "@apollo/client";

const CREATE_USER = gql`
  mutation UserCreate($inputs: [CreateUserAccountInput!]!) {
    userCreate(inputs: $inputs) {
      id
      name
      role
    }
  }
`;

const REQEUST_ACCOUNT = gql`
  mutation accountRegister($inputs: [CreateUserAccountInput!]!) {
    accountRegister(inputs: $inputs) {
      id
      name
      role
    }
  }
`;

export { CREATE_USER, REQEUST_ACCOUNT };
